module.exports = __webpack_public_path__ + "img/Step_3_Sustain_T850.066132f4.png";